export const PROGRESS_TYPES = {
  JOB_ROLE: 0,
  JOB_GOAL: 1,
  JOB_SKILL: 2,
  SKILL_GOAL: 3,
};
